// extracted by mini-css-extract-plugin
module.exports = {"radio":"StaticRadioInput_radio__J18bR","checked":"StaticRadioInput_checked__Kk6j6"};